import React from "react";

const PlainDHLogo = () => {
  return (
    <svg width="78" height="43" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M35.368 12.16C31.138-.345 20.01.053 20.01.053H0v1.599s3.992.239 4.61 2.791v34.066C3.991 41.06 0 41.297 0 41.297v1.601h17.95c8.091-.208 14.814-5.1 17.591-12.86 2.9-9.046-.173-17.877-.173-17.877zM7.125 38.66h-1.24V4.276h1.24v34.382zm8.735 1.443c-3.35-.336-3.394-3.114-3.394-3.114L12.45 3.315s2.028-.734 6.278-.58c0 0 3.818-.187 6.307 3.896 0 0 2.405 3.95 2.576 10.375l.096 3.996s.155 7.75-1.736 11.993c-2.838 7.895-10.11 7.108-10.11 7.108zm8.318-1.955s4.985-3.52 5.149-16.867c.03-.129.088-2.115-.04-3.76-.173-2.184-.547-4.15-.547-4.15-1.31-7.739-4.633-9.658-4.737-9.716 4.19 1.326 6.38 8.352 6.615 15.751.261 8.231-1.902 16.923-6.44 18.742z"
        fill="#0091AC"
      />
      <path
        d="M77.373 1.53V0H58.24v1.53s3.852.04 5.176 2.532v14.962H48.487V4.063s.715-2.237 5.218-2.512V.02H34.573V1.55s3.851.038 5.175 2.532v34.792c-1.324 2.493-5.177 2.532-5.177 2.532v1.53h19.134v-1.53c-4.503-.276-5.218-2.512-5.218-2.512V21.797h14.929v17.057c-1.324 2.492-5.176 2.53-5.176 2.53v1.532h19.133v-1.532c-4.502-.273-5.217-2.509-5.217-2.509V4.041s.715-2.237 5.217-2.51zM42.5 38.86h-1.374V4.276h1.374V38.86zm23.718-.019h-1.374V4.26h1.374V38.84z"
        fill="#0091AC"
      />
    </svg>
  );
};

export default PlainDHLogo;
